"use client";

import { usePathname } from "next/navigation";
import Footer from "./default";

const HIDDEN_PATHS = ["/encomendas/web-view"];

export default function ConditionalFooter() {
  const pathname = usePathname();
  if (HIDDEN_PATHS.includes(pathname)) return null;
  return <Footer />;
}
